import { Box, Skeleton } from "@mui/material"

export default function CartItemSkeleton() {
  return (
    <Box mt={2} display="flex" alignItems="center">
      <Box mr={2}>
        <Skeleton variant="rounded" width={66} height={66} />
      </Box>
      <Box flex={1} mr={2}>
        <Skeleton />
        <Skeleton animation="wave" />
        <Skeleton animation={false} />
      </Box>
      <Skeleton width={80} />
    </Box>
  )
}
